import React from "react";

import Popup from "./Popup";
import SocialMediaUser from "./SocialMediaUser";

//SVG's
import Facebook from "../svgs/Facebook";
import WhatsApp from "../svgs/WhatsApp";
import Telegram from "../svgs/Telegram";
import Instagram from "../svgs/Instagram";

import { useForm } from "react-hook-form";
import { useAuth } from "../providers/auth";

//API
import api from "../services/api";

const PopupChooseChat = ({ trigger, socialMedias, setTrigger, setSelectedMedia, idCustomer, fetchMessagesById, handleChatBack, blockLongPooling, setAvailable }) => {

  const { user } = useAuth();

  const { register, handleSubmit } = useForm();

  const onSubmit = data => {
    setSelectedMedia(data.social_media);
    startNovoChat(data.social_media);
    setTrigger(false);
    blockLongPooling.current = false;
  };

  function getMediaType(media) {
    switch (media) {
      case "Whatsapp":
        return <WhatsApp />;

      case "Instagram":
        return <Instagram />;

      case "Facebook":
        return <Facebook />;

      case "Telegram":
        return <Telegram />;
    }
  }

  // Nova Conversa
  const startNovoChat = async (media) => {
    try {
      const response = await api.post("/chats/new/vacation/" + idCustomer, { social_media: media }, { headers: { "Authorization": "Bearer " + user.token } });

      fetchMessagesById(response.data.chat_id, idCustomer, 1);
      handleChatBack();
      setAvailable(false)
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <Popup title="Escolher rede social para o chat" trigger={trigger} setTrigger={setTrigger} >
      <div className="sm-body">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row-grid">

            {socialMedias.map((media, index) => {
              return (
                <SocialMediaUser title={media} name="social_media" value={media} register={register} >
                  {getMediaType(media)}
                </SocialMediaUser>
              )
            })}

          </div>

          <div className="popup-footer">
            <button className="btn btn-primary" type="submit">Concluir</button>
            <button className="btn btn-light mr-20" type="submit" onClick={() => setTrigger(false)}>Cancelar</button>
          </div>
        </form>
      </div>
    </Popup>
  );
}

export default PopupChooseChat;